import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AccordionDetails, AccordionSummary, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// CONSTANTS
import { BITTERSWEET, KOURNIKOVA, ROYAL_BLUE_2, SHAMROCK } from '@/constants/colors';

// STYLES
import { AccordionStyled } from './styles';

const features = [
  {
    id: 1,
    title: 'common.features.features1.title',
    description: 'common.features.features1.desc',
    icon: 'movie-stars',
    color: BITTERSWEET,
  },
  {
    id: 2,
    title: 'common.features.features2.title',
    description: 'common.features.features2.desc',
    icon: 'compass-filled',
    color: SHAMROCK,
  },
  {
    id: 3,
    title: 'common.features.features3.title',
    description: 'common.features.features3.desc',
    icon: 'coin',
    color: ROYAL_BLUE_2,
  },
  {
    id: 4,
    title: 'common.features.features4.title',
    description: 'common.features.features4.desc',
    icon: 'bookmark',
    color: KOURNIKOVA,
  },
];

const Features = ({ extendedByDefault }) => {
  const [t] = useTranslation();
  const [expanded, setExpanded] = useState(extendedByDefault ? features[0].id : 0);

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div className="features">
      <Typography className="m-b-30" variant="h4">
        {t('common.features.title')}
      </Typography>
      {features.map(item => {
        const isExpanded = expanded === item.id;

        return (
          <AccordionStyled
            className="accordion"
            square
            expanded={isExpanded}
            onChange={handleChange(item.id)}
            color={item.color}
            key={item.id}
          >
            <AccordionSummary
              className="accordion__summary"
              aria-controls="panel-content"
              expandIcon={<i className={`icon-${isExpanded ? 'minus' : 'plus'}`} />}
            >
              <div className="accordion__icon">
                <i className={`icon-${item.icon}`} />
              </div>
              <Typography variant="h6">{t(item.title)}</Typography>
            </AccordionSummary>
            <AccordionDetails className="accordion__details">
              <Typography className="p4">{t(item.description)}</Typography>
            </AccordionDetails>
          </AccordionStyled>
        );
      })}
    </div>
  );
};

Features.defaultProps = {
  extendedByDefault: true,
};

Features.propTypes = {
  extendedByDefault: PropTypes.bool,
};

export default React.memo(Features);
